import moment from 'moment';

export const findMonth = (monthNumber) => {
  const mapping = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
    '1': 'Jan',
    '2': 'Feb',
    '3': 'Mar',
    '4': 'Apr',
    '5': 'May',
    '6': 'Jun',
    '7': 'Jul',
    '8': 'Aug',
    '9': 'Sep',
  };

  return mapping[monthNumber];
};

export const findAllMonthLabels = (startDate, endDate) => {
  const startYear = String(startDate).slice(2, 4);
  const startMonth = String(startDate).slice(4, 6);
  const constructedStartDate = moment(
    `01-${startMonth}-${startYear}`,
    'DD-MM-YY',
  );

  const endYear = String(endDate).slice(2, 4);
  const endMonth = String(endDate).slice(4, 6);
  const constructedEndDate = moment(`01-${endMonth}-${endYear}`, 'DD-MM-YY');

  let index = constructedStartDate;
  const labels = {};

  while (index <= constructedEndDate) {
    const formattedIndex = index.format('YYYY-MM-DD').split('-');
    const indexMonth = formattedIndex[1];
    const indexYear = formattedIndex[0];
    const label = `${findMonth(indexMonth)} ${indexYear.slice(2, 4)}`;

    labels[Number(`${indexYear}${indexMonth}`)] = label;
    index = index.add(1, 'month');
  }

  return labels;
};

export const findWeeklyLabels = (startDate, endDate) => {
  if (startDate && endDate) {
    const startYear = String(startDate).slice(0, 4);
    const startWeek = Number(String(startDate).slice(6, 8));

    const endYear = String(endDate).slice(0, 4);
    const endWeek = Number(String(endDate).slice(6, 8));
    const constructedEndDate = moment(endYear).week(endWeek).endOf('week');

    let index = moment(startYear).week(startWeek).startOf('week');
    let weekcount = Number(startWeek);
    const labels = {};

    while (index < constructedEndDate) {
      const calcStartDate = moment(startYear).week(weekcount).startOf('week');
      const calcEndDate = moment(startYear).week(weekcount).endOf('week');

      const startString = `${calcStartDate.format('DD')} ${findMonth(
        calcStartDate.format('MM'),
      )} ${calcStartDate.format('YY')}`;
      const endString = `${calcEndDate.format('DD')} ${findMonth(
        calcEndDate.format('MM'),
      )} ${calcEndDate.format('YY')}`;

      labels[
        Number(
          `${calcStartDate.format('YY')}${calcStartDate.format(
            'MM',
          )}${calcStartDate.format('DD')}`,
        )
      ] = `${startString} - ${endString}`;
      index = moment(startYear).week(weekcount).endOf('week');
      weekcount += 1;
    }

    return labels;
  }

  return {};
};
